export default "__VITE_ASSET__CIHS95aL__"